import {
    CheckIcon,
    CloudArrowDownIcon,
    CloudArrowUpIcon,
    ExclamationTriangleIcon,
} from "@heroicons/react/24/outline";
import { WarningIcon } from "components/ui/icon";
import React from "react";

interface StatusMessageProps {
    mode: "icon" | "icon-and-text";
}
export const SentStatusMessage: React.FC<StatusMessageProps> = ({ mode }) => {
    return (
        <div
            className="flex items-center space-x-1 text-gray-400"
            role="img"
            aria-label="Sent"
            title="Sent">
            <CloudArrowUpIcon className="w-5 h-5" />
            {mode === "icon-and-text" && <span className="text-sm">Sent</span>}
        </div>
    );
};

export const ReceivedStatusMessage: React.FC<StatusMessageProps> = ({ mode }) => {
    return (
        <div
            className="flex items-center space-x-1 text-green-600"
            role="img"
            aria-label="Received"
            title="Received">
            <CloudArrowDownIcon className="w-5 h-5" />
            {mode === "icon-and-text" && <span className="text-sm">Received</span>}
        </div>
    );
};

export const BouncedStatusMessage: React.FC<StatusMessageProps> = ({ mode }) => {
    return (
        <div
            className="flex items-center space-x-1 text-yellow-600"
            role="img"
            aria-label="Bounced"
            title="Bounced">
            <WarningIcon className="w-5 h-5" />
            {mode === "icon-and-text" && <span className="text-sm">Bounced</span>}
        </div>
    );
};

export const NotDeliveredStatusMessage: React.FC<StatusMessageProps> = ({ mode }) => {
    return (
        <div
            className="flex items-center space-x-1 text-red-500"
            role="img"
            aria-label="Send failed — message was not delivered"
            title="Send failed — message was not delivered. See details below.">
            <ExclamationTriangleIcon className="w-5 h-5" />
            {mode === "icon-and-text" && <span className="text-sm">Not delivered</span>}
        </div>
    );
};

export const DeliveredStatusMessage: React.FC<StatusMessageProps> = ({ mode }) => {
    return (
        <div
            className="flex items-center space-x-1 text-green-600"
            role="img"
            aria-label="Delivered"
            title="Delivered">
            <div className="relative w-5 h-5">
                <CheckIcon className="w-4 h-4 absolute top-0.5 left-0" />
                <CheckIcon className="w-4 h-4 absolute top-0.5 left-1" />
            </div>
            {mode === "icon-and-text" && <span className="text-sm">Delivered</span>}
        </div>
    );
};

export const SendingStatusMessage: React.FC<StatusMessageProps> = ({ mode }) => {
    return (
        <div
            className="flex items-center space-x-1 text-gray-400"
            role="img"
            aria-label="Sending"
            title="Sending">
            <CloudArrowUpIcon className="w-5 h-5" />
            {mode === "icon-and-text" && <span className="text-sm">Sending</span>}
        </div>
    );
};
